exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-in {\r\n    background-color: #ef3b2b;\r\n    /* background-color: #AD310B; */\r\n    -webkit-transition: background-color 1000ms linear;\r\n    transition: background-color 1000ms linear;\r\n}\r\n\r\n.revize-button-li{\r\n    height: 22px;\r\n    margin: 10px;\r\n}\r\n\r\n.revize-button{\r\n    padding: 6px;\r\n    border: unset;\r\n    background-color: #ef3b2b !important;\r\n    font-weight: bold;\r\n    color: #fff;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/reply/reply.component.css
// module id = ../../../../../src/app/post-item/reply/reply.component.css
// module chunks = main